var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardicon01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.8189 13.7022H3V52.7394H51.8189V13.7022Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8189 30.4963L27.4318 37.2407L3 30.4963V16.6501H51.8189V30.4963Z",
    fill: "#B12825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8189 27.5037L27.4318 34.2481L3 27.5037V13.7022H51.8189V27.5037Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.432 5.03722C31.2731 5.03722 34.4444 8.16377 34.4444 12.0496H37.4816C37.4816 6.51117 32.9704 2 27.432 2C21.8935 2 17.3823 6.51117 17.3823 12.0496H20.4195C20.4195 8.20844 23.5461 5.03722 27.432 5.03722Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4323 36.5707C29.0603 36.5707 30.3802 35.2509 30.3802 33.6228C30.3802 31.9947 29.0603 30.6749 27.4323 30.6749C25.8042 30.6749 24.4844 31.9947 24.4844 33.6228C24.4844 35.2509 25.8042 36.5707 27.4323 36.5707Z",
    fill: "#B12825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4322 35.0522C28.2216 35.0522 28.8615 34.4123 28.8615 33.6229C28.8615 32.8335 28.2216 32.1936 27.4322 32.1936C26.6428 32.1936 26.0029 32.8335 26.0029 33.6229C26.0029 34.4123 26.6428 35.0522 27.4322 35.0522Z",
    fill: "#E9E6D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3701 32.9975C28.3701 33.5335 27.9681 33.9355 27.4321 33.9355C26.8961 33.9355 26.4941 33.5335 26.4941 32.9975V32.1042C26.4941 31.5682 26.8961 31.1663 27.4321 31.1663C27.9681 31.1663 28.3701 31.5682 28.3701 32.1042V32.9975Z",
    fill: "#B12825"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.8189,
    height: 50.6948,
    fill: "white",
    transform: "translate(3 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardicon01);
export default __webpack_public_path__ + "static/media/cardicon01.ae1b3735bf9cb8284384b8eb3de10110.svg";
export { ForwardRef as ReactComponent };